import * as React from "react";
import { UitkCard, UitkCardContentSection } from "@egds/react-core/cards";
import { UitkIcon } from "@egds/react-core/icons";
import { MobileMenuProps, DesktopMenuProps, Landmark } from "../typings";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkHeading, UitkParagraph } from "@egds/react-core/text";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkLayoutPosition } from "@egds/react-core/layout-position";

const generateLandmarksList = (landmarks: Landmark[]) =>
  landmarks.map((landmark: Landmark) => (
    <li key={landmark.id} role="menuitem" tabIndex={0} onClick={landmark.onClick}>
      <UitkIcon name="place" />
      {landmark.title}
      <UitkParagraph className="is-visually-hidden">{landmark.description}</UitkParagraph>
    </li>
  ));

export const MobileMenu = (props: MobileMenuProps) => (
  <UitkCard>
    <UitkCardContentSection border="bottom">
      <div className="mobile-nav-card__toggle" onClick={props.toggle}>
        <UitkLayoutFlex tabIndex={0} justifyContent="space-between">
          <UitkLayoutFlexItem>
            <div>
              <UitkHeading tag="h2" size={5}>
                {props.title}
              </UitkHeading>
            </div>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <UitkIcon name={props.isOpen ? "expand_more" : "expand_less"} />
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </div>
    </UitkCardContentSection>
    <UitkCardContentSection padded={false}>
      <ul className="map-menu__items">{generateLandmarksList(props.landmarks)}</ul>
    </UitkCardContentSection>
  </UitkCard>
);

export const DesktopMenu = (props: DesktopMenuProps) => (
  <UitkLayoutPosition type="absolute" position={{ top: "twelve", left: "four", zindex: "layer7" }}>
    <UitkSpacing margin={{ blockstart: "four" }}>
      <UitkCard className="map-explorer">
        <UitkCardContentSection border="bottom">
          <div>
            <UitkHeading tag="h2" size={5}>
              {props.title}
            </UitkHeading>
          </div>
        </UitkCardContentSection>
        <UitkCardContentSection padded={false}>
          <ul className="map-menu__items">{generateLandmarksList(props.landmarks)}</ul>
        </UitkCardContentSection>
      </UitkCard>
    </UitkSpacing>
  </UitkLayoutPosition>
);
